import { render, staticRenderFns } from "./BluredBackground.vue?vue&type=template&id=77fa3532&lang=pug&"
import script from "./BluredBackground.vue?vue&type=script&lang=ts&"
export * from "./BluredBackground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports